import React from "react";
import { Link } from "react-router-dom";

export default function NewsCard({ article, size = "md" }) {
  const sizes = {
    sm: { img: "h-32", title: "text-base" },
    md: { img: "h-48", title: "text-lg" },
    lg: { img: "h-64", title: "text-2xl" },
  };
  const s = sizes[size] || sizes.md;
  const date = new Date(article.created_at);

  return (
    <Link
      to={`/news/${article.id}`}
      data-testid={`news-card-${article.id}`}
      className="news-card group block bg-[#0a0a0b] border border-white/10 hover:bg-[#101012]"
    >
      {article.image_url ? (
        <div className={`w-full ${s.img} overflow-hidden bg-zinc-900`}>
          <img
            src={article.image_url}
            alt={article.title}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          />
        </div>
      ) : (
        <div className={`w-full ${s.img} bg-gradient-to-br from-zinc-900 to-black`} />
      )}
      <div className="p-5">
        {article.category_slug && (
          <span className="inline-block px-2 py-1 text-[10px] font-mono uppercase tracking-widest bg-yellow-400/10 text-yellow-400 border border-yellow-400/20 mb-3">
            {article.category_slug.replace("-", " ")}
          </span>
        )}
        <h3 className={`font-display font-bold ${s.title} text-white leading-snug group-hover:text-yellow-400 transition-colors`}>
          {article.title}
        </h3>
        {article.excerpt && size !== "sm" && (
          <p className="mt-3 text-sm text-zinc-400 line-clamp-2">{article.excerpt}</p>
        )}
        <div className="mt-4 flex items-center gap-3 text-xs font-mono text-zinc-500">
          <span>{article.author_name || "HashRate"}</span>
          <span>•</span>
          <span>{date.toLocaleDateString()}</span>
        </div>
      </div>
    </Link>
  );
}
